import { useApiCall } from "./useApiCall";
import { useCallback } from "react";
import { IUserLoginResponse } from "../interfaces/admin/user/userLoginResponse";
import { IUserForm, IUserFormRes } from "../interfaces/admin/user/userForm";
import { IRole } from "../interfaces/common/roles"
import { IViewingUser } from "../interfaces/admin/user/viewingUser";
import { IPublishingUser } from "../interfaces/admin/user/publishingUser";
import { IOthersAdmins } from "../interfaces/admin/user/othersAdmins";
import { useUsersStore } from '../store/hooks/useUsersStore';
import { useAreasStore } from "../store/hooks";
import { UsersWithAreas } from "../interfaces/admin/user/usersWithAreas";

export const useUsersApi = () => {
  const {api} = useApiCall();
  const usersStore = useUsersStore()
  const areasStore = useAreasStore()

  const addUser = useCallback(
    async (userForm: IUserForm) => {
      const res: IUserLoginResponse = await api.apiInstance.post('user', userForm, true);
      return !!res;
    },
    [api.apiInstance]
  );

  const getPublishingUsers = useCallback(async (isLoading: boolean = true) => {
    const res: UsersWithAreas<IPublishingUser> = await api.apiInstance.get('users/publishing', isLoading);
    if (res) {
      usersStore.setPublishingUsers(res.items)
      areasStore.setAreas(res.areas)
    }
  }, [api.apiInstance, areasStore, usersStore])

  const getViewingUsers = useCallback(async (isLoading: boolean = true) => {
    const res: UsersWithAreas<IViewingUser> = await api.apiInstance.get('users/participant', isLoading);
    if (res) {
      usersStore.setViewingUsers(res.items)
      areasStore.setAreas(res.areas)
    }
  }, [api.apiInstance, areasStore, usersStore])

  const getOtherUsers = useCallback(async (roles: IRole[], isLoading: boolean = true) => {
    const res: UsersWithAreas<IOthersAdmins> = await api.apiInstance.get('users', isLoading);
    if (res) {
      usersStore.setOtherUsers(res.items, roles)
      areasStore.setAreas(res.areas)
    }
  }, [api.apiInstance, areasStore, usersStore])

  const resendActivateEmail = useCallback(async (id: number) => {
    const res = await api.apiInstance.post(`/user/${id}/resend-activate-email`, {});
    return !!res;
  }, [api.apiInstance])

  const deleteUser = useCallback(async (id: number) => {
    const res = await api.apiInstance.delete(`/user/${id}`);
    return !!res;
  }, [api.apiInstance])

  const editUser = useCallback(async (userForm: IUserForm) => {
    if (userForm.id) {
      const res = await api.apiInstance.put(`/user/${userForm.id}`, userForm);
      return !!res;
    }

  }, [api.apiInstance])

  const getUser = useCallback(async (id: number) => {
    const res: IUserFormRes = await api.apiInstance.get(`/user/${id}`);
    if (res) {
      const user = {
        ...res, areas: res.areas.map(el => el.id)
      }
      usersStore.setUserEdit(user, id)
    }
    return !!res;
  }, [api.apiInstance, usersStore])


  return {
    getUser,
    deleteUser,
    editUser,
    resendActivateEmail,
    addUser,
    getPublishingUsers,
    getViewingUsers,
    getOtherUsers
  }
}